function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_9757",
  "data-name": "Group 9757",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_11368",
  "data-name": "Path 11368",
  d: "M11834.863,4030.635l-1.095,5.548a.424.424,0,0,1-.418.343.414.414,0,0,1-.264-.095l-3.155-2.557a.418.418,0,0,1-.153-.412l.73-3.688a1.12,1.12,0,0,0-1.1-1.334h-8.968a1.117,1.117,0,0,0-1.1,1.334l.728,3.688a.431.431,0,0,1-.148.412l-3.155,2.557a.427.427,0,0,1-.687-.248l-1.094-5.548a5.556,5.556,0,0,1,5.452-6.635h8.968a5.555,5.555,0,0,1,5.451,6.635Z",
  transform: "translate(-11812.932 -4024)"
}), React.createElement("path", {
  id: "Path_11369",
  "data-name": "Path 11369",
  d: "M12000.935,4030.635l-1.1,5.548a.427.427,0,0,1-.271.318.424.424,0,0,1-.412-.07l-3.157-2.557a.426.426,0,0,1-.147-.412l.728-3.688a1.117,1.117,0,0,0-1.094-1.334H11991V4024h4.485a5.559,5.559,0,0,1,5.45,6.635Z",
  transform: "translate(-11979.016 -4024)"
}), React.createElement("path", {
  id: "Path_11370",
  "data-name": "Path 11370",
  d: "M11804.512,4173.773a11.978,11.978,0,0,1-3.788,8.747,2.078,2.078,0,0,1-1.426.563h-13.569a2.08,2.08,0,0,1-1.425-.564h0a11.979,11.979,0,0,1-.146-17.334,11.5,11.5,0,0,1,8.354-3.406,12.35,12.35,0,0,1,8.542,3.572,11.927,11.927,0,0,1,3.457,8.423Z",
  transform: "translate(-11780.521 -4153.933)"
}), React.createElement("path", {
  id: "Path_11371",
  "data-name": "Path 11371",
  d: "M12002.994,4173.794a11.986,11.986,0,0,1-3.787,8.748,2.079,2.079,0,0,1-1.423.563H11991v-21.3a12.343,12.343,0,0,1,8.54,3.572,11.923,11.923,0,0,1,3.455,8.422Z",
  transform: "translate(-11979.016 -4153.955)"
}));

var SvgWorkoutLibrary = function SvgWorkoutLibrary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_17013",
    "data-name": "Group 17013",
    width: 23.992,
    height: 29.148,
    viewBox: "0 0 23.992 29.148",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWorkoutLibrary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Workout_library.ccbf3033.svg";
export { ForwardRef as ReactComponent };